import React, { FC } from 'react';
import classNames from 'classnames';
import { BrandDirectIconType } from '../../../types/shopConfig/shopConfigV2';
import { IconBrandDirect } from '../..';
import { useShopConfigV2 } from '../../../hooks/shopConfig';
import { useShopCss } from '../../../hooks/useShopCss';
import { useActivePromos } from '../../../hooks/useActivePromos';
import CustomIcon from '../../CustomIcon/CustomIcon';
import css from './IconBrandDirectExplainer.module.css';

interface IconBrandDirectExplainerProps {
  className?: string;
}

const IconBrandDirectExplainer: FC<IconBrandDirectExplainerProps> = (props) => {
  const { className } = props;

  const { brandDirectIconType } = useShopConfigV2();
  const { brandDirectIcon } = useShopCss();
  const { activePromoBrandDirectIconUrl } = useActivePromos();

  const brandDirectIconClasses = classNames(css.brandDirectIcon, className);
  const customBrandDirectIconClasses = classNames(css.customBrandDirectIcon, className);

  // If the brand has a promo active that includes
  // a custom brand direct icon, use that here.
  if (activePromoBrandDirectIconUrl) {
    return (
      <CustomIcon
        url={activePromoBrandDirectIconUrl}
        altText="brand-direct-promo"
        className={customBrandDirectIconClasses}
        imgStyleOverrides={{ height: 'auto' }}
      />
    );
  }

  // Custom contentful brand direct icon
  if (brandDirectIcon) {
    return (
      <CustomIcon
        url={brandDirectIcon.url}
        altText="brand-direct"
        className={customBrandDirectIconClasses}
        imgStyleOverrides={{ height: 'auto' }}
      />
    );
  }

  // Fall back to default or none
  switch (brandDirectIconType) {
    // BEGIN DEPRECATED
    case BrandDirectIconType.Dopple:
    case BrandDirectIconType.DL1961:
    case BrandDirectIconType.Sale25Off:
    case BrandDirectIconType.Sale30Off:
    case BrandDirectIconType.Sale50Off:
    case BrandDirectIconType.Sale70Off:
    case BrandDirectIconType.ElizabethSuzann:
    case BrandDirectIconType.GoldieAndAce:
      return <IconBrandDirect className={brandDirectIconClasses} />;
    // END DEPRECATED
    case BrandDirectIconType.Default:
      return <IconBrandDirect className={brandDirectIconClasses} />;
    case BrandDirectIconType.None:
      return null;
    default:
      return <IconBrandDirect className={brandDirectIconClasses} />;
  }
};

export default IconBrandDirectExplainer;
